import React, { useState, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';

const DashboardLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div>
      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
      <div className="lg:pl-72">
        <Topbar setSidebarOpen={setSidebarOpen} />
        <main className="py-10 pt-5 bg-gray-100 dark:bg-gradient-to-t dark:from-gray-800 dark:to-black min-h-[100dvh]">
          {children}
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
